(function () {
  'use strict';
  var ACTIVE = false;
  try {
    var toggle = new URLSearchParams(location.search).get('rxdebug');
    if (toggle === '1') localStorage.setItem('rxDebug', '1');
    if (toggle === '0') localStorage.removeItem('rxDebug');
    ACTIVE = localStorage.getItem('rxDebug') === '1';
  } catch (error) {}
  if (!ACTIVE || (window.rxDebug && window.rxDebug.version === '2.0.0')) return;

  var storageKey = 'rxDebugLogV2';
  var buffer = [];
  try { buffer = JSON.parse(sessionStorage.getItem(storageKey) || '[]'); } catch (error) {}
  if (!Array.isArray(buffer)) buffer = [];

  function path(url) {
    try { return new URL(url, location.href).pathname.replace(/(\/checkouts\/cn\/)[^/]+/, '$1[token]'); }
    catch (error) { return '[invalid URL]'; }
  }
  function cartRequest(url) {
    try {
      var parsed = new URL(url, location.href);
      return parsed.origin === location.origin && /(?:^|\/)cart(?:\/(?:add|change|update|clear))?(?:\.js)?\/?$/.test(parsed.pathname);
    } catch (error) { return false; }
  }
  function push(kind, label, data) {
    if (!ACTIVE) return;
    var entry = { t: new Date().toISOString(), kind: kind, label: label, url: path(location.href), data: data || null };
    buffer.push(entry);
    if (buffer.length > 300) buffer.splice(0, buffer.length - 300);
    try { sessionStorage.setItem(storageKey, JSON.stringify(buffer)); } catch (error) {}
    try { console.info('[RX-DBG]', kind, label, data || ''); } catch (error) {}
  }
  function tokenHash(value) {
    var hash = 2166136261;
    var text = String(value || '');
    for (var i = 0; i < text.length; i++) hash = Math.imul(hash ^ text.charCodeAt(i), 16777619);
    return (hash >>> 0).toString(16);
  }
  function summary(data) {
    var result = {};
    if (!data || typeof data !== 'object') return result;
    ['item_count', 'total_price', 'currency', 'status'].forEach(function (key) { if (data[key] !== undefined) result[key] = data[key]; });
    if (data.token) result.token_hash = tokenHash(data.token);
    var items = Array.isArray(data.items) ? data.items : (data.variant_id ? [data] : []);
    result.items = items.map(function (item) { return { variant_id: item.variant_id || item.id, quantity: item.quantity, final_price: item.final_price }; });
    return result;
  }
  function fields(form) {
    var result = {};
    Array.prototype.forEach.call(form.elements || [], function (element) {
      if (!/^(id|quantity|updates\[\]|checkout|update)$/.test(element.name)) return;
      if (element.name === 'updates[]') (result.updates || (result.updates = [])).push(element.value);
      else result[element.name] = element.value;
    });
    return result;
  }
  var nativeFetch = window.fetch;
  function snapshot(label) {
    return nativeFetch.call(window, '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) { push('error', label, { status: response.status }); return; }
      return response.json().then(function (data) { var state = summary(data); push('cart', label, state); return state; });
    }).catch(function (error) { push('error', label, { message: String(error.message).slice(0,160) }); });
  }
  window.rxDebug = {
    version: '2.0.0',
    log: push,
    state: function () { return buffer.slice(); },
    dump: function () { console.table(buffer); return buffer.slice(); },
    clear: function () { buffer = []; try { sessionStorage.removeItem(storageKey); sessionStorage.removeItem('rxDebugLog'); } catch (error) {} },
    off: function () { ACTIVE = false; try { localStorage.removeItem('rxDebug'); } catch (error) {} },
    cart: function () { return snapshot('manual /cart.js'); }
  };

  // Observe the native setter without blocking, restoring or changing cookies.
  try {
    var descriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    if (descriptor && descriptor.configurable && descriptor.get && descriptor.set) {
      var names = function (doc) { try { return descriptor.get.call(doc).split(';').map(function (cookie) { return cookie.trim().split('=')[0]; }).filter(Boolean); } catch (error) { return []; } };
      Object.defineProperty(Document.prototype, 'cookie', {
        configurable: descriptor.configurable, enumerable: descriptor.enumerable, get: descriptor.get,
        set: function (value) {
          var text = typeof value === 'string' ? value : '';
          var name = text.split('=')[0].trim();
          var watched = ACTIVE && /^(cart|cart_currency|localization|_tracking_consent|_shopify_essential|_shopify_test|discount_code)$/.test(name);
          var before = watched ? names(this) : [];
          var stack = watched ? String(new Error().stack || '').slice(0,1800) : '';
          var result = descriptor.set.call(this, value);
          if (watched) push('cookie', 'write ' + name, {
            name: name, attributes: text.split(';').slice(1).join(';'),
            empty: text.slice(text.indexOf('=') + 1).split(';')[0] === '',
            present_before: before.indexOf(name) !== -1, present_after: names(this).indexOf(name) !== -1,
            stack: stack
          });
          return result;
        }
      });
    }
  } catch (error) { push('error', 'cookie observer unavailable', {}); }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input);
    var method = (init && init.method) || (input && input.method) || 'GET';
    var watched = ACTIVE && cartRequest(url);
    if (watched) push('request', method + ' ' + path(url), {});
    return nativeFetch.apply(this, arguments).then(function (response) {
      if (watched) {
        push('response', method + ' ' + path(url), { status: response.status });
        try { response.clone().json().then(function (data) { push('cart', method + ' ' + path(url), summary(data)); }).catch(function () {}); } catch (error) {}
      }
      return response;
    }, function (error) { if (watched) push('error', method + ' ' + path(url), { message: String(error.message).slice(0,160) }); throw error; });
  };
  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this.__rxDebugRequest = { method: method, url: url }; return nativeOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    var request = xhr.__rxDebugRequest;
    if (ACTIVE && request && cartRequest(request.url)) {
      push('request', 'XHR ' + request.method + ' ' + path(request.url), {});
      xhr.addEventListener('load', function () {
        push('response', 'XHR ' + request.method + ' ' + path(request.url), { status: xhr.status });
        try { push('cart', 'XHR result', summary(xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText))); } catch (error) {}
      }, { once: true });
    }
    return nativeSend.apply(this, arguments);
  };
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !cartRequest(form.action)) return;
    push('submit', path(form.action), { submitter: event.submitter ? event.submitter.name : null, fields: fields(form), defaultPrevented: event.defaultPrevented });
  }, true);
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('a,button') : null;
    if (!target) return;
    if (target.href && /\/(cart|checkout)(?:[/?]|$)/.test(target.href)) push('click', path(target.href), {});
    if (target.name === 'checkout') push('click', 'checkout button', {});
  }, true);
  window.addEventListener('pagehide', function (event) { push('navigation', 'pagehide', { persisted: event.persisted }); });
  window.addEventListener('pageshow', function (event) { push('navigation', 'pageshow', { persisted: event.persisted }); });
  window.addEventListener('load', function () { snapshot('load /cart.js'); });
  push('boot', 'RX-DBG 2 active before GTM; cookie values and personal form fields are omitted', {});
})();
